import { render, staticRenderFns } from "./cardReceived.vue?vue&type=template&id=89edbc1c&"
import script from "./cardReceived.vue?vue&type=script&lang=js&"
export * from "./cardReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports